import AccordionContainer from './accordion-container';

export default AccordionContainer;